const defineVuesticPlugin = (fabric) => fabric;
export {
  defineVuesticPlugin as d
};
//# sourceMappingURL=define-vuestic-plugin-8c565dfe.mjs.map
